import { notify } from "../model/datatype";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export const NotifyModal = (props: notify) => {
  const { t } = useTranslation();
  const text = props.btnText ? props.btnText : "ตกลง";
  const width = "100%";
  const type = props.type ? props.type : "text";
  const btnConfirm = props.btnConfirm ? props.btnConfirm : "no";
  const [load, setLoad] = useState(true);
  function ramdomNumber() {
    return Math.floor(Math.random() * 90000) + 10000;
  }
  useEffect(() => {
    // if (props.body) {
    //   setLoad(false);
    // }
  }, []);
  return (
    <Modal
      id="nofitfyModal"
      onExiting={props.onExiting}
      show={props.showModal}
      onHide={props.handleContinue}
      backdrop={props.backdrop}
      keyboard={props.keyboard}
      centered
      style={props.Style}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      {type === "text" ? (
        <Modal.Body className="modal-alert-body text-center p-4">
          {props.body}
        </Modal.Body>
      ) : (
        ""
      )}
      {type === "images" ? (
        <Modal.Body className="modal-alert-body text-center">
          <a href={props.body + "?v=" + ramdomNumber()} target="_bank">
            <img
              alt="images"
              src={props.body + "?v=" + ramdomNumber()}
              width={width}
              onLoad={() => setLoad(false)}
            />
          </a>
        </Modal.Body>
      ) : (
        ""
      )}
      <Modal.Footer className="modal-alert-footer">
        {btnConfirm === "yes" ? (
          <>
            <Button
              variant="success btn-yes"
              onClick={props.confirmFunc}
              style={{ width: 100 }}
            >
              {t("btn_confirm")}
            </Button>
            <Button
              variant="danger btn-no"
              onClick={props.onHide}
              style={{ width: 100 }}
            >
              {t("btn_cancel")}
            </Button>
          </>
        ) : (
          ""
        )}

        {btnConfirm === "no" ? (
          <Button
            variant="primary btn-yes-none"
            onClick={props.onHide}
            style={{ width: 100 }}
          >
            {text}
          </Button>
        ) : (
          ""
        )}
      </Modal.Footer>
    </Modal>
  );
};
